/* Application name */
export const APP_NAME = 'Beställ förmånsintyg';
export const APP_SLUG = 'exp-vue-bestallformansintyg';

/* URL to fetch texts */
export const APP_TRANSLATIONS_URL = '/fk_apps/GenerelltREST/public/v2/wcmcontent/fmibestallblankett?';

/**
 * URL to navigate to when returning from the application, e.g. when aborting or
 * navigating from receipt.
 *
 * Examples:
 *
 * - Oinloggat: /wps/portal
 * - Inloggad:  /wps/myportal/privatpers/minasidor
 */
export const APP_ENTRY_POINT_URL = '/wps/portal';
